export const graphqlClientId = 'hops-homepage';
